module.exports = __webpack_public_path__ + "static/media/slider-thumb.351c1923.png";